import CalendarFolder from 'owa-service/lib/contract/CalendarFolder';
import RequestStatus from '../store/schema/RequestStatus';
import { action } from 'satcheljs';

export const addToAgendaMailDisabledMap = action(
    'ADD_TO_AGENDA_DISABLED_MAP',
    (folderId: string, agendaMailDisabledToUpdate: boolean) => ({
        folderId,
        agendaMailDisabledToUpdate,
    })
);

export const loadCalendarFoldersToStore = action(
    'LOAD_CALERDAR_FOLDERS_TO_STORE',
    (calendarFolders: CalendarFolder[]) => ({
        calendarFolders,
    })
);

export const saveAgendaMailOption = action('SAVE_AGENDA_MAIL_OPTION');

export const discardAgendaMailOption = action('DISCARD_AGENDA_MAIL_OPTION');

export const setAgendaMailEnabled = action(
    'SET_AGENDA_MAIL_ENABLED',
    (isEnabledToSet: boolean) => ({ isEnabledToSet })
);

export const updateAgendaMailDisabledForFolder = action(
    'UPDATE_AGENDA_MAIL_DISABLED_FOR_FOLDER',
    (folder: CalendarFolder, newAgendaDisabledValue: boolean) => ({
        folder,
        newAgendaDisabledValue,
    })
);

export const setGetCalendarFolderServiceStatus = action(
    'SET_GET_CALENDAR_FOLDERS_SERVICE_STATUS',
    (status: RequestStatus) => ({ status })
);
